import {TextField} from "@mui/material";
import React, {useEffect} from "react";
import CustomButton from "../../../Shared/CustomButton";
import CustomDiv from "../../../Shared/CustomDiv";
import Text from "../../../Shared/Text";
import contactLogo from "../../../Assets/Contact us.gif";
import {useState} from "react";
import axiosInstance from "../../../Config/axios";
import {API_URLS} from "../../../Config/API_URLS";
import {useNavigate} from "react-router-dom";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  const addQuiry = () => {
    const reqbody = new FormData();
    reqbody.append("name", fname);
    reqbody.append("title", lname);
    reqbody.append("description", msg);
    reqbody.append("inquiry_type", email);

    axiosInstance
      .post(API_URLS.addQuiry, reqbody)
      .then((response) => {
        alert(response.data.message);
        response.data.response_code === 200 && window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleInputChange = (e) => {
    const newValue = e.target.value;

    if (!/[^a-zA-Z]/.test(newValue)) {
      setLname(newValue);
    } else {
      setLname("");
    }
  };
  const handleInputChangea = (e) => {
    const newValue = e.target.value;

    if (!/[^a-zA-Z]/.test(newValue)) {
      setFname(newValue);
    } else {
      setFname("");
    }
  };

  return (
    <>
      <CustomDiv className="flex w-full bg-gray-100 p-[2%] lg:px-[2%]">
        <CustomDiv className="flex lg:flex-row flex-col w-full shadow">
          <CustomDiv className="flex w-full flex-col gap-5 items-center bg-white py-9 ">
            <Text className="text-4xl font-semibold my-10">Enquiry Form</Text>
            <span className="grid lg:grid-cols-2 gap-4 lg:w-2/3 w-11/12">
              <span className="w-full">
                <Text> Name*</Text>
                <TextField
                  type="text"
                  placeholder="Enter First Name"
                  color="primary"
                  size="small"
                  className="w-full"
                  value={fname}
                  onChange={(e) => handleInputChangea(e)}
                />
              </span>
              <span className="w-full">
                <Text>Title*</Text>
                <TextField
                  placeholder="Enter Title"
                  color="primary"
                  size="small"
                  className="w-full"
                  value={lname}
                  onChange={(e) => handleInputChange(e)}
                />
              </span>
            </span>
            <span className="lg:w-2/3 w-11/12">
              <Text>Inquiry Type*</Text>
              <TextField
                placeholder="Enter Inquiry Type"
                color="primary"
                size="small"
                className="w-full"
                onChange={(e) => setEmail(e.target.value)}
              />
            </span>

            <span className="lg:w-2/3 w-11/12">
              <Text>Description*</Text>
              <TextField
                placeholder="Enter Description"
                color="primary"
                size="small"
                multiline
                rows={4}
                className="w-full"
                onChange={(e) => setMsg(e.target.value)}
              />
            </span>
            <CustomButton onClick={addQuiry} className="w-1/4">
              Submit
            </CustomButton>
          </CustomDiv>
          {/* <CustomDiv className="flex flex-col lg:w-1/2 lg:pt-40 lg:px-4 bg-white">
            <img src={"https://images.unsplash.com/photo-1484807352052-23338990c6c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y29udGFjdCUyMGZvcm18ZW58MHx8MHx8fDA%3D&w=1000&q=80"} alt="" className="!rounded-l" />
          </CustomDiv> */}
        </CustomDiv>
      </CustomDiv>
    </>
  );
};

export default ContactUs;
